<div class="primary-div">

    <div class="screen-options white-card max-auto">
        
        <div class="left-side">
            <div class="screen-title">
                Vendas presenciais
            </div>
        </div>

        <div class="right-side">

            <div style="width: 270px; margin-right: 6px;" class="div-date">
                <input matInput [placeholder]="range.value.start == null ? 'De - Até' : ''" 
                    class="input" readonly style="width: 270px;">

                <mat-form-field class="input-date" color="accent"  matTooltip="Busca por data (De - Até)">

                    <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
                        <input matStartDate formControlName="start" placeholder="" readonly 
                            (click)="picker.open()" (dateChange)="getSales(1, true)">
                        <input matEndDate formControlName="end" placeholder="" readonly 
                            (click)="picker.open()" (dateChange)="getSales(1, true)">
                    </mat-date-range-input>

                    <mat-datepicker-toggle *ngIf="range.value.start == null || range.value.end == null"
                        matSuffix [for]="picker" ></mat-datepicker-toggle>

                    <mat-datepicker-toggle matSuffix (click)="clearDate($event)" 
                        *ngIf="range.value.start != null && range.value.end != null">
                        <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                    </mat-datepicker-toggle>
                    
                    <mat-date-range-picker #picker></mat-date-range-picker>
                </mat-form-field>
            </div>

            <input matInput placeholder="Busca por evento..." [(ngModel)]="search_event" class="input"
                matTooltip="Busque pelo nome do evento" autocomplete="off" (ngModelChange)="getSales(1, true)">

            <input matInput placeholder="Busca por vendedor..." [(ngModel)]="search_seller" class="input"
                matTooltip="Busque pelo nome do vendedor" autocomplete="off" (ngModelChange)="getSales(1, true)">
        </div>

    </div>

    <div style="padding: 50px; text-align: center;" *ngIf="!is_loaded" class="max-auto">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    </div>

    <div style="padding: 15px 0; overflow-x: auto;" *ngIf="is_loaded" class="max-auto">

        <table mat-table [dataSource]="data_source" class="mat-elevation-z8 table-class">
            <ng-container matColumnDef="event">
                <th mat-header-cell *matHeaderCellDef mat-sort-header > Evento </th>
                <td mat-cell *matCellDef="let data"> {{data.event?.name}} </td>
            </ng-container>

            <ng-container matColumnDef="value">
                <th mat-header-cell *matHeaderCellDef mat-sort-header > Valor </th>
                <td mat-cell *matCellDef="let data"> {{convertMoney(data.amount / 100)}} </td>
            </ng-container>

            <ng-container matColumnDef="quantity">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="text-align: center;"> Quantidade </th>
                <td mat-cell *matCellDef="let data" style="text-align: center;"> {{data.ticketQuantity}} </td>
            </ng-container>

            <ng-container matColumnDef="code">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Código </th>
                <td mat-cell *matCellDef="let data"> {{data.coupon?.exchangeCode}} </td>
            </ng-container>

            <ng-container matColumnDef="car">
                <th mat-header-cell *matHeaderCellDef mat-sort-header > Veículo </th>
                <td mat-cell *matCellDef="let data"> 
                    {{data.vehicle_type == 'car' ? 'Carro' :
                      data.vehicle_type == 'van' ? 'Van' : 
                      data.vehicle_type == 'bus' ? 'Ônibus' : data.vehicle_type}}
                </td>
            </ng-container>
    
            <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef mat-sort-header > Tipo de pagamento </th>
                <td mat-cell *matCellDef="let data"> 
                    {{  data.paymentType == 'credit' ? 'Cartão de crédito' :
                        data.paymentType == 'cash' ? 'Dinheiro' :
                        data.paymentType == 'debit' ? 'Cartão de Débito' : data.paymentType }} 
                </td>
            </ng-container>

            <ng-container matColumnDef="partner">
                <th mat-header-cell *matHeaderCellDef mat-sort-header > Desconto de Sócio </th>
                <td mat-cell *matCellDef="let data"> 
                    {{  data.isPartnerDiscountUsed ? 'Sim' : 'Não' }} 
                </td>
            </ng-container>

            <ng-container matColumnDef="userthatsold">
                <th mat-header-cell *matHeaderCellDef mat-sort-header > Vendedor </th>
                <td mat-cell *matCellDef="let data"> 
                    {{data.userThatSold?.name}} <br>
                    {{data.userThatSold?.email}}
                </td>
            </ng-container>

            <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="text-align: left; text-align: start;" > Data </th>
                <td mat-cell *matCellDef="let data" style="text-align: left; text-align: start;">
                    {{data.createdAt | date: 'dd/MM/yyyy'}}
                </td>
            </ng-container>
    
            <tr mat-header-row *matHeaderRowDef="displayedColumns" class="header-table"></tr>
            <tr mat-row *matRowDef="let data; columns: displayedColumns;"></tr>
        </table>

        <div class="table-paginator">
            <div>
                Mostrando {{page_count1}}-{{page_count2}} de {{count_total}}
            </div>
            
            <div style="display: flex;">
                
                <div class="paginator-button prev" (click)="prev()" matTooltipPosition="above"
                [matTooltip]="page == 1 ? 'Sem página anterior' : 'Página anterior'"
                [ngStyle]="{'opacity': page == 1 ? '0.4' : '1' }">
                    <img src="/assets/icons/prev.png" width="12px" height="12px">
                </div>
                
                <div class="paginator-button next" (click)="next()" matTooltipPosition="above"
                [matTooltip]="page_count2 < count_total ? 'Pŕoxima página' : 'Sem próxima página'"
                [ngStyle]="{'opacity': page_count2 < count_total ? '1' : '0.4' }">
                    <img src="/assets/icons/next.png" width="12px" height="12px">
                </div>
                
			</div>
        </div>

    </div>

</div>